import { errorHandler } from '@autopass-web/domain';

class PaymentError {
  // apple pay api

  applePayUnavailable = () => {
    return {
      state: 'apple_pay_unavailable',
      message: '無法使用 apple pay',
    };
  };

  applePayMerchantValidation = () => {
    return {
      stage: 'apple_pay_merchant_validation',
      message: 'Apple Pay 交易驗證失敗，請重新再試。',
    };
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  applePayPaymentAuthorized = (error: any) => {
    const result = errorHandler(error);

    switch (result.code) {
      case 'send_paid_to_kiosk_fail':
        return {
          stage: 'send_paid_to_kiosk',
          message:
            '商家連線失敗，無法完成最終交易，請改用現場其他方式重新付款。稍後系統將自動刷退此筆交易，請安心！',
        };
      default:
        return {
          stage: 'apple_pay_payment_authorized',
          message: '付款失敗，請重新檢查「Apple Pay」付款設定。',
        };
    }
  };

  applePayCancel = () => {
    return {
      isLocalError: true,
      stage: 'apple_pay_cancel',
      message: 'Apple Pay 交易已取消，請重新再試。',
      code: 'apple_pay_cancel',
    };
  };

  applePayDuplicateOrders = () => {
    return {
      stage: 'apple_pay_duplicate_orders',
      message: '已有訂單繳費中，請重新再試。',
    };
  };

  applePayInit = () => {
    return {
      stage: 'apple_pay_init_fail',
      message: 'apple pay 無法啟動，請重新再試。',
    };
  };
}

export default new PaymentError();
